import { ActionReducerMap } from '@ngrx/store';
import { LoginState } from 'app/store/login/login.state';
import { loggedUserReducer } from 'app/store/login/logged-user/logged-user.reducer';
import { assignedProjectsReducer } from 'app/store/login/assigned-projects/assigned-projects.reducer';

export const loginReducer: ActionReducerMap<LoginState, any> = {
  assignedProjects: assignedProjectsReducer,
  loggedUser: loggedUserReducer
};
